import { Component } from '@angular/core';
import { PlanComponent } from '../plan/plan.component';
import { PriceAnimationDirective } from './price-animation.directive';

@Component({
  selector: 'app-signup-pricing',
  standalone: true,
  imports: [PlanComponent,PriceAnimationDirective],
  templateUrl: './signup-pricing.component.html',
  styleUrl: './signup-pricing.component.scss'
})
export class SignupPricingComponent {
 
}
